import React from "react";

import Checkbox from "@mui/material/Checkbox";
import Stack from "@mui/material/Stack";
import {useTranslation} from "react-i18next";



const ColumnHeader = (props) => {
    const {permission, resourcesType, multipleCheck, accessRules, ruleEditState} = props;
    const {t} = useTranslation("acl", "enums");
    const renderPermissionHeader = (permission) => {
        const pUpperCase = permission.toUpperCase().replace(':', '_');
        switch(resourcesType){
            case "station":
                return t(`enums:station_permission.${pUpperCase}`);
            case "workgroup":
                return t(`enums:wg_permission.${pUpperCase}`);
            default:
                return permission;
        }
    }

    const selectedRuleCount = ruleEditState.countSelectedRules(permission, accessRules);
    const areAllRulesSelected = selectedRuleCount > 0 && selectedRuleCount === accessRules.length;
    const areSomeRulesSelected = selectedRuleCount > 0 && selectedRuleCount < accessRules.length;

    return <Stack>
        <span>{renderPermissionHeader(permission)}</span>
        {multipleCheck && <Checkbox checked={areAllRulesSelected}
                                    indeterminate={areSomeRulesSelected}
                                    onChange={() => ruleEditState.toggleAllRules(permission, accessRules)}
                                    color="info"/>}
    </Stack>
}

export default ColumnHeader;